  <section class="sheet bg-white">
    <div class="sheet-content">
      <slot></slot>
    </div>
  </section>